export { StartPage } from "./Start";
export { FavoriteDessertPage } from "./FavoriteDessert";
export { FlavourGroupsPage } from "./FlavourGroups";
export { CoffeeColorPage } from "./CoffeeColor";
export { LoadingResultsPage } from "./LoadingResults";
export { ResultsPage } from "./Results";
